import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import CircleToggle from '../circle-toggle';
import Duration from '../duration';
import Icon from '../icon';
import Tooltip from '../tooltip';
import Link from '../link';

import {
	Container,
	ImageContainer,
	Image,
	NotificationContainer,
	NotificationText,
	DurationWrapper,
	MenuContainer
} from './notification.css';

import { cdn } from '~/modules/services/image-service';

function Notification(props) {
	const {
		notification,
		toNotification,
		onNotificationClick,
		updateReadStatus
	} = props;

	const isRead = notification.read;
	const dropdownRef = useRef(null);

	const handleNotificationClick = (e) => {
		if( dropdownRef.current.contains(e.target) ) {
			return;
		}
		onNotificationClick(notification);
	};

	return (
		<Container
			onClick={handleNotificationClick}
			data-testid="notification"
		>
			<ImageContainer>
				<Link to={toNotification(notification)}>
					<Image url={cdn(notification.poster)} />
				</Link>
			</ImageContainer>

			<NotificationContainer data-testid="notification-content">
				<Link to={toNotification(notification)}>
					<NotificationText read={isRead}>
						{notification.title}
						&nbsp;&nbsp;&nbsp;
						<DurationWrapper>
							<Icon use="clock" color="silver-base" />
							<Duration timestamp={notification.added} size={0.9} />
						</DurationWrapper>
					</NotificationText>
				</Link>
			</NotificationContainer>

			<MenuContainer
				ref={dropdownRef}
			>
				<Tooltip text={`Mark as ${isRead ? 'unread' : 'read'}`} position="left" size={8} delay>
					<label htmlFor={`markUnread-${notification._id}`}>
						<CircleToggle
							name={`markUnread-${notification._id}`}
							id={`markUnread-${notification._id}`}
							checked={!isRead}
							onChange={() => updateReadStatus(notification)}
							data-testid="mark-unread"
						/>
					</label>
				</Tooltip>
			</MenuContainer>
		</Container>
	);
}

Notification.propTypes = {
	notification: PropTypes.object.isRequired,
	toNotification: PropTypes.func,
	onNotificationClick: PropTypes.func,
	updateReadStatus: PropTypes.func
};

export default Notification;
